import React from "react";
import type { HeadingProps } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";

export const H3B = (props: HeadingProps) => (
  <Heading
    as="h3"
    fontSize={{ base: "md", sm: "md", md: "lg", lg: "25px" }}
    {...props}
  />
);
